import { createReducer } from 'redux-create-reducer'
import type { EmailCampaign } from 'types/campaign'
import {
  CAMPAIGN_LIST_BEGIN_CREATING,
  CAMPAIGN_LIST_CANCEL_CREATING,
  CAMPAIGN_LIST_CREATE,
  CAMPAIGN_LIST_CREATE_FAIL,
  CAMPAIGN_LIST_CREATE_SUCCESS,
  CAMPAIGN_LIST_MODAL_UPDATE,
} from '@disco/constants/ActionTypes'
export type State = {
  visible: boolean
  campaign: Partial<EmailCampaign> | null | undefined
}
const initialState: State = {
  visible: false,
  campaign: null,
}
export const newCampaignModal = createReducer<State, any>(initialState, {
  [CAMPAIGN_LIST_BEGIN_CREATING](state, action) {
    return {
      ...state,
      visible: true,
      campaign: { ...state.campaign, type: action.campaignType },
    }
  },

  [CAMPAIGN_LIST_CANCEL_CREATING](state) {
    return { ...state, visible: false }
  },

  [CAMPAIGN_LIST_MODAL_UPDATE](state, action) {
    return {
      ...state,
      campaign: { ...state.campaign, ...action.updatedFields },
    }
  },

  [CAMPAIGN_LIST_CREATE](state) {
    return { ...state, campaign: { ...state.campaign, saving: true } }
  },

  [CAMPAIGN_LIST_CREATE_SUCCESS](state) {
    return { ...state, visible: false, campaign: null }
  },

  [CAMPAIGN_LIST_CREATE_FAIL](state) {
    return { ...state, campaign: { ...state.campaign, saving: false } }
  },
})
